/**
 * @generated SignedSource<<ed69fb48f7995af29395e9295a91bf67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortfolioProjectAdminActions_portfolioProject$data = {
  readonly id: string;
  readonly searchRankBoost: number;
  readonly " $fragmentType": "PortfolioProjectAdminActions_portfolioProject";
};
export type PortfolioProjectAdminActions_portfolioProject$key = {
  readonly " $data"?: PortfolioProjectAdminActions_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"PortfolioProjectAdminActions_portfolioProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PortfolioProjectAdminActions_portfolioProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchRankBoost",
      "storageKey": null
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};

(node as any).hash = "d9bf0c4da076624beb25dd0357e6f50b";

export default node;
